export default "__VITE_ASSET__DF583glf__"